import * as constants from "../stores/constants";
import { toImmutableList } from "../utils/stuff";

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {string} field
 */
export var setField = function setField(config, path, field) {
  return {
    type: constants.SET_FIELD,
    path: toImmutableList(path),
    field: field,
    config: config
  };
};

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {*} srcKey
 */
export var setFieldSrc = function setFieldSrc(config, path, srcKey) {
  return {
    type: constants.SET_FIELD_SRC,
    path: toImmutableList(path),
    srcKey: srcKey,
    config: config
  };
};

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {string} operator
 */
export var setOperator = function setOperator(config, path, operator) {
  return {
    type: constants.SET_OPERATOR,
    path: toImmutableList(path),
    operator: operator,
    config: config
  };
};

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {integer} delta
 * @param {*} value
 * @param {string} valueType
 * @param {*} asyncListValues
 * @param {boolean} __isInternal
 */
export var setValue = function setValue(config, path, delta, value, valueType, asyncListValues, __isInternal) {
  return {
    type: constants.SET_VALUE,
    path: toImmutableList(path),
    delta: delta,
    value: value,
    valueType: valueType,
    asyncListValues: asyncListValues,
    config: config,
    __isInternal: __isInternal
  };
};

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {integer} delta
 * @param {*} srcKey
 */
export var setValueSrc = function setValueSrc(config, path, delta, srcKey) {
  return {
    type: constants.SET_VALUE_SRC,
    path: toImmutableList(path),
    delta: delta,
    srcKey: srcKey,
    config: config
  };
};

/**
 * @param {object} config
 * @param {Immutable.List} path
 * @param {string} name
 * @param {*} value
 */
export var setOperatorOption = function setOperatorOption(config, path, name, value) {
  return {
    type: constants.SET_OPERATOR_OPTION,
    path: toImmutableList(path),
    name: name,
    value: value,
    config: config
  };
};